import { useState } from "react";
import styled from "styled-components";
import fipayFonts from "../../theme/index";
import TextFields from "../../components/TextField/text-field.component";
import { Input } from "@mui/material";
import { InfoCircle } from "../../../public/assets";
import InfoCircles from "./InfoCircles";

const AdvancedOptionsContent = styled.div`
  padding-bottom: 20px;
  margin-left: -10px;
`;

const AdvancedOptionsContentText = styled.div`
  padding-top: 10px;
`;

const AdvancedOptionsContentText1 = styled.div`
  padding-top: 10px;
`;

const AdvancedDualInput = styled.div`
  padding-top: 30px;
`;

const AdvancedDualLabel = styled.label`
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

const AdvancedOptionsContentText2 = styled.div`
  padding-top: 10px;
  width: 100%;
  display: grid;
  grid-template-columns: 60% 35%;
  margin-left: 15px;
`;

const AdvancedDualInputlabelImg = styled.div`
  display: flex;
  align-items: center;
  width: 94%;
  margin: 0 auto;
`;

const AdvancedInput = styled.input`
  width: 76%;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e8eaed;
  margin-left: 15px;
  padding: 2px 0px 2px 10px;
  // color: #cfcfcf;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

const PreviewPaymentInput3 = styled.input`
  width: 100%;
  height: 45px;
  border-radius: 10px;
  border: 1px solid #e8eaed;
  padding: 5px 10px;
  padding: 2px 0px 2px 10px;
  // color: #cfcfcf;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

const PreviewPaymentInput4 = styled.input`
  width: 45%;
  height: 45px;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 1px solid #e8eaed;
  padding: 5px 10px;
  padding: 2px 0px 2px 10px;
  // color: #b9b8b8;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

interface AdvancedProps {
  handleChange: any;
  formData: any;
}

const AdvancedOptions: React.FC<AdvancedProps> = ({
  handleChange,
  formData,
}) => {
  const handleInputChangeClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
  };

  return (
    <AdvancedOptionsContent onClick={handleInputChangeClick}>
      <AdvancedDualInput>
        <AdvancedDualInputlabelImg>
          <AdvancedDualLabel>Use your custom link(Optional)</AdvancedDualLabel>{" "}
          <InfoCircles message="Your custom URL will be included in the payment link" />
        </AdvancedDualInputlabelImg>
        <AdvancedOptionsContentText>
          <AdvancedInput
            type="text"
            name="successMessage"
            value={formData.successMessage}
            onChange={handleChange}
          />
          {/* <TextFields
          height="30px"
          width="80%"
          type="text"
          label="Success message (Optional)"
          showIcon={true}
          name="successMessage"
          value={formData.successMessage}
          onChange={handleChange}
        /> */}
        </AdvancedOptionsContentText>
      </AdvancedDualInput>
      <AdvancedDualInput>
        <AdvancedDualInputlabelImg>
          {" "}
          <AdvancedDualLabel>Success message (Optional)</AdvancedDualLabel>{" "}
          <InfoCircles message="Message displayed upon a successful payment" />
        </AdvancedDualInputlabelImg>
        <AdvancedOptionsContentText2>
          <PreviewPaymentInput3
            value={formData.useYourCustomLink}
            name="useYourCustomLink"
            onChange={handleChange}
            placeholder="fipay.io/paymentlink/username/"
          />
          <PreviewPaymentInput4
            value={formData.url}
            name="url"
            onChange={handleChange}
            placeholder="{your-url}"
          />
        </AdvancedOptionsContentText2>
      </AdvancedDualInput>

      <AdvancedDualInput>
        <AdvancedDualInputlabelImg>
          <AdvancedDualLabel>
            Redirect after payment (Optional)
          </AdvancedDualLabel>{" "}
          <InfoCircles message="Your customers will be redirected to this site after payment" />
        </AdvancedDualInputlabelImg>
        <AdvancedOptionsContentText1>
          <AdvancedInput
            type="text"
            name="redirectAfterPayment"
            value={formData.redirectAfterPayment}
            onChange={handleChange}
          />
          {/* <TextFields
          height="30px"
          width="80%"
          type="text"
          name="redirectAfterPayment"
          label="Redirect after payment(Optional)"
          showIcon={true}
          value={formData.redirectAfterPayment}
          onChange={handleChange}
        /> */}
          {/* <img src="/assets/svg/info-circle.svg" alt="" /> */}
        </AdvancedOptionsContentText1>
      </AdvancedDualInput>
    </AdvancedOptionsContent>
  );
};

export default AdvancedOptions;
